import {filter} from "lodash"

import Products from "../enums/Products"
import Product from "../types/Product"
import productList from "./productList"

export function getActiveProducts(): Product[] {
  return filter(productList(), (product: Product) => product.active)
}

export function getInactiveProducts(): Product[] {
  const productsNotActive = filter(productList(), (product: Product) => !product.active)
  const products = productsNotActive.map((product: Product) => {
    switch (product.product) {
      case Products.perks:
      case Products.recognition:
        return product
      default:
        return null
    }
  })

  return filter(products, (product: Product) => !!product)
}

